export const getBadgeDisplayName = (shape: string) => {
  switch (shape) {
    case "oval":
      return "Keg Badge - Oval";
    case "square":
      return "Keg Badge - Square";
    case "circle":
      return "Keg Badge - Circle";
    case "pumpClip":
      return "Cask Badge - Pump clip";
    case "ovalFisheye":
      return "Keg Fisheye Lens - Oval";
    case "circleFisheye":
      return "Keg Fisheye Lens - Circle";
    default:
      return undefined;
  }
};
